import { render, staticRenderFns } from "./r-smart-offer-bundle-hub.vue?vue&type=template&id=461605bd"
import script from "./r-smart-offer-bundle-hub.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-hub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('461605bd')) {
      api.createRecord('461605bd', component.options)
    } else {
      api.reload('461605bd', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-hub.vue?vue&type=template&id=461605bd", function () {
      api.rerender('461605bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-hub/r-smart-offer-bundle-hub.vue"
export default component.exports